import { useEffect, useState } from 'react';
import { retrieveRawInitData, retrieveLaunchParams } from '@telegram-apps/sdk';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';
import { ProgressSpinner } from 'primereact/progressspinner';
import TgApi from '@/api/tg_api.ts';
import { useParams } from 'react-router';
import './tg_ai_chat.scss';
import clsx from 'clsx';
import { useTgStore } from '@/stores/tg';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';

export default function AITextPage() {
  const { answerUid } = useParams();
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);
  const [initDataRaw, setInitDataRaw] = useState<any>(null);
  const { tgTheme, setTgTheme } = useTgStore();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    async function init() {
      const initDataRaw = retrieveRawInitData();
      setInitDataRaw(initDataRaw);
      const params = retrieveLaunchParams();
      const theme = params.tgWebAppThemeParams?.bg_color === '#ffffff' ? 'light' : 'dark';
      setTgTheme(theme);
      if (theme === 'dark') {
        import('highlight.js/styles/github-dark.css');
      } else {
        import('highlight.js/styles/github.css');
      }
    }

    init();
  }, []);

  function convertLaTeXToMarkdown(text: string) {
    return text
      .replace(/\\\((.*?)\\\)/gs, (_, p1) => `$${p1.replace(/\\\\/g, '\\')}$`)
      .replace(/\\\[(.*?)\\\]/gs, (_, p1) => `$$${p1.replace(/\\\\/g, '\\')}$$`);
  }

  const getText = async () => {
    if (!answerUid || !initDataRaw) return;
    try {
      const answerAi = await TgApi.getAiAnswer(answerUid, initDataRaw);
      setText(convertLaTeXToMarkdown(answerAi));
    } catch (error) {
      console.error('Error getting files:', error);
      return;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void getText();
  }, [answerUid, initDataRaw]);

  return (
    <div className={clsx('ai-page', tgTheme)}>
      <div className="ai-full-card">
        <div className="gradient-text-container">
          <h2>
            <span>✨ </span>
            <span className={clsx('gradient-text', tgTheme)}>Ответ от Repeteka AI</span>
          </h2>
        </div>
        {
          <div className={clsx('ai-card', 'p-card-shadow', tgTheme)}>
            {loading ? (
              <div className="loading-spinner">
                <ProgressSpinner />
              </div>
            ) : (
              <div className={clsx('answer-text', 'markdown', tgTheme)}>
                <ReactMarkdown
                  remarkPlugins={[remarkMath, remarkGfm]}
                  rehypePlugins={[rehypeKatex, rehypeHighlight]}
                >
                  {text}
                </ReactMarkdown>
              </div>
            )}
          </div>
        }
      </div>
    </div>
  );
}
